import type { HttpResponse } from '../data.d';
import http from '../http';

const MODEL = '/api_key';
const underlineParams = { params: { switchReqToUnderline: true } };

export default {
  getList(data: Record<string, any>): Promise<HttpResponse> {
    return http.post(`${MODEL}/list`, data, underlineParams);
  },
  // 校验名称重复
  checkName(data: Record<string, any>): Promise<HttpResponse> {
    return http.post(`${MODEL}/check_name`, data, underlineParams);
  },
  onCreate(data: Record<string, any>): Promise<HttpResponse> {
    return http.post(`${MODEL}/create`, data, underlineParams);
  },
  onEdit(data: Record<string, any>): Promise<HttpResponse> {
    return http.post(`${MODEL}/edit`, data, underlineParams);
  },
  onDelete(data: Record<string, any>): Promise<HttpResponse> {
    return http.post(`${MODEL}/delete`, data, underlineParams);
  },
};
